import request from '@/utils/request'
const BASE_URL = '/ClientPrice'

export default {
    list(data) {
        return request({
            url: BASE_URL + '/List',
            method: 'post',
            data
        })
    },
    save(data) {
        return request({
            url: BASE_URL + '/Save',
            method: 'post',
            data
        })
    },
    delete(data) {
        return request({
            url: BASE_URL + '/Delete',
            method: 'post',
            data
        })
    },
}